import { FC } from "react";
import { IconProps } from "./types";

export const XMarkMediumCircle: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm5.686-15.411L14.274 12l3.412 3.411a1.072 1.072 0 0 1 0 1.517l-.758.758a1.072 1.072 0 0 1-1.517 0L12 14.274l-3.411 3.412a1.071 1.071 0 0 1-1.517 0l-.758-.758a1.072 1.072 0 0 1 0-1.517L9.726 12 6.314 8.589a1.07 1.07 0 0 1 0-1.517l.758-.758a1.069 1.069 0 0 1 1.517 0L12 9.726l3.411-3.412a1.072 1.072 0 0 1 1.517 0l.758.758a1.072 1.072 0 0 1 0 1.517z"
      fill={fill}
    />
  </svg>
);
